import { useUIStore } from '@/stores/uiStore';
import { useTranslation } from 'react-i18next';

export default function DownloadIndicator() {
  const { isDownloading, downloadProgress } = useUIStore();
  const { t } = useTranslation();

  if (!isDownloading) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center gap-3">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          <span className="font-medium">{downloadProgress || t('common.downloading')}</span>
        </div>
        <span className="text-sm text-blue-100">{t('common.downloadWait')}</span>
      </div>
    </div>
  );
}
